import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../../shared/modal/content';
import PopupHeader from '../../popupHeader';
import CenterPanelUpdate from './centerPanelUpdate';
import CenterPanelView from './centerPanelView';
import RightPanelTop from './rightPanelTop';

export default function WaitingAreaDuringCallsContent(props) {
  let orgName = props.waitingArea ? props.waitingArea.organisationName : '';
  let subtitle = (props.waitingArea ? props.waitingArea.name : '') + ' (' + orgName + ')';

  let centerPanel = '';
  let rightPanel = '';
  rightPanel = (
    <RightPanelTop
      waitingArea={props.waitingArea}
      duringCallsForm={props.duringCallsForm}
      updatingDuringCallsDetail={props.updatingDuringCallsDetail}
      updateOrView={props.updateOrView}
    />
  );
  if (props.updateOrView == 'update') {
    centerPanel = (
      <CenterPanelUpdate
        duringCallsForm={props.duringCallsForm}
        waitingArea={props.waitingArea}
        isRecordingAvailableOnPortal={props.isRecordingAvailableOnPortal}
        callQualityOptions={props.callQualityOptions}
        isWaitingAreaBulletinEnabled={props.isWaitingAreaBulletinEnabled}
      />
    );
  } else {
    centerPanel = (
      <CenterPanelView
        duringCallsForm={props.duringCallsForm}
        waitingArea={props.waitingArea}
        isRecordingAvailableOnPortal={props.isRecordingAvailableOnPortal}
        callQualityOptions={props.callQualityOptions}
        isWaitingAreaBulletinEnabled={props.isWaitingAreaBulletinEnabled}
      />
    );
  }

  return (
    <Modal
      show={
        props.showDuringCallsModal &&
        props.isRecordingAvailableOnPortal !== null &&
        props.callQualityOptions !== null &&
        props.callQualityOptions.length > 0
      }
      hideWhenClickAway={false}
    >
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpDuringCalls}
        title={APP.LANGUAGE.DuringCallsModal.Title}
        subtitle={subtitle}
      />
      <div className="content">
        <div className="main-ui-container waiting-area-during-calls">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
